import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export function SidebarReactivationBillingBadge({
  count,
  variant,
}: {
  count: number;
  variant?: SidebarCountBadgeVariant;
}) {
  const { t } = useTranslation('reactivation_billing');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-reactivation-billing-badge"
      label={t('badge_aria', { count })}
    />
  );
}
